module.exports = new __parcel__URL__("user.9e1a57e3.webp").toString();